import { render, staticRenderFns } from "./LocaleSelector.vue?vue&type=template&id=1d201bdb&scoped=true&"
import script from "./LocaleSelector.vue?vue&type=script&lang=js&"
export * from "./LocaleSelector.vue?vue&type=script&lang=js&"
import style0 from "./LocaleSelector.vue?vue&type=style&index=0&id=1d201bdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d201bdb",
  null
  
)

export default component.exports